// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listselect {
  display: flex;
  flex-direction: row;
  height: 100%;
}
.listselect .listbox {
  width: 50%;
  border: 1px solid var(--gc-color-light);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}
.listselect .listbox .header {
  padding: 0.5rem;
  font-weight: 500;
  color: var(--gc-color-light-contrast);
}
.listselect .listbox:first-of-type .header {
  background-color: var(--gc-color-light);
}
.listselect .listbox:last-of-type .header {
  background-color: var(--gc-color-primary);
  color: var(--gc-color-primary-contrast);
}
.listselect .listbox .content {
  overflow: overlay;
}
.listselect .listbox .content .entry {
  display: inline-block;
  border: 2px solid transparent;
  border-radius: 5px;
  margin: 0.25rem;
  -webkit-user-select: none;
          user-select: none;
  background-color: var(--gc-color-light);
  color: var(--gc-color-light-contrast);
  padding: 0.5rem;
}
.listselect .listbox .content .entry:hover {
  cursor: pointer;
  background-color: rgba(var(--gc-color-primary-rgb), 0.8);
  color: var(--gc-color-primary-contrast);
}
.listselect .listbox .content .entry.selected {
  background-color: var(--gc-color-primary);
  color: var(--gc-color-primary-contrast);
}
.listselect .listbox .content .entry.highlighted {
  background-color: yellow;
}
.listselect .action {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.listselect .action .action-button {
  margin: 2px 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-dual-select/v-dual-select.component.sass"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAAJ;AACI;EACI,UAAA;EACA,uCAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;AAAR;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,qCAAA;AAAZ;AAEY;EACI,uCAAA;AAAhB;AAEY;EACI,yCAAA;EACA,uCAAA;AAAhB;AACQ;EACI,iBAAA;AACZ;AACY;EACI,qBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uCAAA;EACA,qCAAA;EACA,eAAA;AAChB;AAAgB;EACI,eAAA;EACA,wDAAA;EACA,uCAAA;AAEpB;AADgB;EACI,yCAAA;EACA,uCAAA;AAGpB;AAFgB;EACI,wBAAA;AAIpB;AAHI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAKR;AAJQ;EACI,eAAA;AAMZ","sourcesContent":["\n.listselect\n    display: flex\n    flex-direction: row\n    height: 100%\n    .listbox\n        width: 50%\n        border: 1px solid var(--gc-color-light)\n        border-radius: 5px\n\n        display: flex\n        flex-direction: column\n\n        .header\n            padding: 0.5rem\n            font-weight: 500\n            color: var(--gc-color-light-contrast)\n        &:first-of-type\n            .header\n                background-color: var(--gc-color-light)\n        &:last-of-type\n            .header\n                background-color: var(--gc-color-primary)\n                color: var(--gc-color-primary-contrast)\n        .content\n            overflow: overlay\n\n            .entry\n                display: inline-block\n                border: 2px solid transparent\n                border-radius: 5px\n                margin: 0.25rem\n                user-select: none\n                background-color: var(--gc-color-light)\n                color: var(--gc-color-light-contrast)\n                padding: 0.5rem\n                &:hover\n                    cursor: pointer\n                    background-color: rgba(var(--gc-color-primary-rgb), 0.8)\n                    color: var(--gc-color-primary-contrast)\n                &.selected\n                    background-color: var(--gc-color-primary)\n                    color: var(--gc-color-primary-contrast)\n                &.highlighted\n                    background-color: yellow\n    .action\n        display: flex\n        flex-direction: column\n        justify-content: center\n        .action-button\n            margin: 2px 5px\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
